let ids = 0;

export default class DCUrl {
  static isRelative (url) {
    return url ? !(url.match(/^https?:\/\//)) : false;
  }

  constructor (domain, url) {
    this.id = ids++;
    this.domain = domain;
    this.url = url;
    this.relative = DCUrl.isRelative(url);
  }

  get fullPath () {
    return (this.url && this.relative) ? `http://${this.domain}${this.url}` : this.url;
  }

  get visibleUrl () {
    return this.url || '(no data)';
  }
}
